import styles from "../../../styles/service/cart.module.scss";
import classNames from "classnames/bind";
import { useEffect, useMemo, useState } from "react";
import { If } from "shared/components/control-statements";
import { OrderStorage } from "storage/OrderStorage";
import { Button, Textarea } from "@components";
import CartItems from "./CartItems";
import { Currency } from "shared/utils/Currency";
const css = classNames.bind(styles);

export default function Cart({ onOpenConfirmOrder, selectedCustomer }) {
  const [collapsed, setCollapsed] = useState(false);
  const [order, setOrder] = useState(OrderStorage.getOrder());
  const [openNotes, setOpenNotes] = useState(false);
  const [observation, setObservation] = useState(order?.observation);

  useEffect(() => {
    const updateOrder = () => {
      const order = OrderStorage.getOrder();
      setOrder(order);
      setObservation(order?.observation);
    };

    window.addEventListener("orderUpdated", updateOrder);

    return () => {
      window.removeEventListener("orderUpdated", updateOrder);
    };
  }, []);

  const totalItems = useMemo(() => {
    return order?.cart?.catalog?.items?.reduce(
      (acc, item) => acc + item.quantity,
      0,
    );
  }, [order]);

  useEffect(() => {
    setCollapsed(totalItems > 0);
  }, [totalItems]);

  useEffect(() => {
    const catalogElement = document.getElementById("catalog");
    const cartElement = document.getElementById("cart");

    if (!catalogElement || !cartElement) return;

    let frameId;

    const updateWidth = () => {
      const width = cartElement.offsetWidth;
      catalogElement.style.maxWidth = `calc(100% - ${width}px - 15px)`;
    };

    updateWidth();

    const observer = new ResizeObserver(() => {
      cancelAnimationFrame(frameId);

      frameId = requestAnimationFrame(() => {
        updateWidth();
      });
    });

    observer.observe(cartElement);

    return () => {
      cancelAnimationFrame(frameId);
      observer.disconnect();
    };
  }, []);

  return (
    <div
      className={css({
        cart: true,
        collapsed: collapsed,
      })}
      onClick={() => !collapsed && setCollapsed(true)}
      id="cart"
    >
      <div
        className={css({ retract: true, active: collapsed })}
        onClick={() => collapsed && setCollapsed(false)}
      >
        <i className="far fa-chevron-left" />
      </div>

      <div className={styles.container}>
        <If cond={!collapsed}>
          <If cond={totalItems === 0}>
            <div className={styles.empty}>
              <i className="fal fa-shopping-cart" />
            </div>
          </If>
        </If>
        <If cond={!collapsed}>
          <If cond={totalItems > 0}>
            <div className={styles.cartQuantity}>{totalItems}</div>
            <div className={styles.cartFooter}>
              <i className="fal fa-shopping-cart" />
            </div>
          </If>
        </If>
        <If cond={collapsed}>
          <If cond={totalItems === 0}>
            <div className={styles.empty}>
              <i className="fal fa-shopping-cart" />

              <p>Carrinho</p>
              <span>A montagem do carrinho irá aparecer por aqui.</span>
            </div>
          </If>

          <If cond={totalItems > 0}>
            <If cond={!openNotes}>
              <div className={styles.header}>
                <p className={styles.title}>Carrinho ({totalItems})</p>
                <Button
                  design="underline"
                  onClick={() => OrderStorage.clearCartItems()}
                >
                  Remover tudo
                </Button>
              </div>

              <If cond={order?.observation}>
                <div className={styles.observation}>
                  <div className="d-flex flex-column">
                    <div className="d-flex align-center gap-10">
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.6 9.1H1.4C1.01281 9.1 0.7 8.78719 0.7 8.4V1.4C0.7 1.01281 1.01281 0.7 1.4 0.7H8.4C8.78719 0.7 9.1 1.01281 9.1 1.4V5.6H7C6.22781 5.6 5.6 6.22781 5.6 7V9.1ZM8.80906 6.3L6.3 8.80906V7C6.3 6.61281 6.61281 6.3 7 6.3H8.80906ZM0 8.4C0 9.17219 0.627813 9.8 1.4 9.8H5.72031C6.09219 9.8 6.44875 9.65344 6.71125 9.39094L9.39094 6.70906C9.65344 6.44656 9.8 6.09 9.8 5.71812V1.4C9.8 0.627813 9.17219 0 8.4 0H1.4C0.627813 0 0 0.627813 0 1.4V8.4Z"
                          fill="#6161FF"
                        />
                      </svg>

                      <p className={styles.label}>OBSERVAÇÃO</p>
                    </div>
                    <p className={styles.observationText}>
                      {order?.observation || "Nenhuma observação"}
                    </p>
                  </div>

                  <div className="d-flex align-center gap-10">
                    <div
                      className={styles.action}
                      onClick={() => setOpenNotes(true)}
                    >
                      <i className="fal fa-pen" />
                    </div>

                    <div className={styles.divider} />

                    <div
                      className={styles.action}
                      onClick={() => OrderStorage.setObservation(null)}
                    >
                      <i className="fal fa-trash" />
                    </div>
                  </div>
                </div>
              </If>

              <div className={styles.itemsContainer}>
                <CartItems />
              </div>

              <div className={styles.footer}>
                <Button
                  design="default-icon-2"
                  onClick={() => setOpenNotes(true)}
                >
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.23333 13.3792H2.05833C1.48908 13.3792 1.02917 12.9193 1.02917 12.35V2.05833C1.02917 1.48908 1.48908 1.02917 2.05833 1.02917H12.35C12.9193 1.02917 13.3792 1.48908 13.3792 2.05833V8.23333H10.2917C9.15637 8.23333 8.23333 9.15637 8.23333 10.2917V13.3792ZM12.9514 9.2625L9.2625 12.9514V10.2917C9.2625 9.72241 9.72241 9.2625 10.2917 9.2625H12.9514ZM0 12.35C0 13.4853 0.923034 14.4083 2.05833 14.4083H8.41022C8.95697 14.4083 9.4812 14.1929 9.86714 13.8069L13.8069 9.86392C14.1929 9.47798 14.4083 8.95375 14.4083 8.40701V2.05833C14.4083 0.923034 13.4853 0 12.35 0H2.05833C0.923034 0 0 0.923034 0 2.05833V12.35Z"
                      fill="#6F767E"
                    />
                  </svg>
                </Button>
                <Button
                  design="primary"
                  className="w-100"
                  disabled={
                    order?.cart?.catalog?.items?.length === 0 ||
                    !selectedCustomer
                  }
                  onClick={onOpenConfirmOrder}
                >
                  Fechar pedido{" "}
                  {Currency.formatCurrency(order?.cart?.total || 0)}
                </Button>
              </div>
            </If>

            <If cond={openNotes}>
              <div className={styles.header}>
                <p className={styles.title}>Observações no pedido</p>
              </div>

              <div className={styles.notes}>
                <Textarea
                  placeholder="Digite as observações do pedido..."
                  value={observation}
                  onChange={(e) => setObservation(e.target.value)}
                />
              </div>

              <div className={styles.footer}>
                <Button className="w-100" onClick={() => setOpenNotes(false)}>
                  Cancelar
                </Button>
                <Button
                  design="primary-2"
                  className="w-100"
                  disabled={!observation}
                  onClick={() => {
                    OrderStorage.setObservation(observation);
                    setOpenNotes(false);
                  }}
                >
                  Salvar
                </Button>
              </div>
            </If>
          </If>
        </If>
      </div>
    </div>
  );
}
